import {
  Layout,
  OrderIconOutlined,
  Page404,
  PageLoading,
  RouterType,
  UserInfo,
} from '@you-go-vn/components';
import { Fragment, lazy, Suspense, useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import LoginPage from './pages/login';
import ForgotPassPage from './pages/login/forgot-pass';
import ResetPasswordPage from './pages/login/reset-password';
import LogoutPage from './pages/logout';
import { useAppDispatch, useAppSelector } from './store';

import {
  AlertOutlined,
  BellOutlined,
  GiftOutlined,
  HistoryOutlined,
  PieChartOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import ForkKnifeOutlinedIcon from '@you-go-vn/components/src/Common/Icons/ForkKnifeOutlinedIcon';

import ChangeDefaultPasswordPage from './pages/login/ChangeDefaultPassword';
import RestaurantPromotionsPage from './pages/promotions/restaurant-promotions';
import YougoPromotionsPage from './pages/promotions/yougo-promotions';
import RestaurantSelector from './pages/restaurant/components/RestaurantSelector';
import RestaurantSelectorMobile from './pages/restaurant/components/RestaurantSelectorMobile';
import { fetchRestaurants } from './pages/restaurant/slice';
import { fetchOrders } from './store/countSlice';
import { OrderTab } from './pages/oders-v2/type';
import { KeyCountStateMenu } from './common/constants';
import RestaurantStatuses from './pages/restaurant/components/RestaurantStatus';
import AddSellingSchedulePage from './pages/menu/selling-schedule/add';
import EditSellingSchedulePage from './pages/menu/selling-schedule/[scheduleId]/edit';

const MenuPage = lazy(() => import('./pages/menu'));
const AddCategoryPage = lazy(() => import('./pages/menu/categories/add'));
const OptionGroupInfoPage = lazy(() => import('./pages/menu/option-group/add'));
const InfoOptionGroupPage = lazy(
  () => import('./pages/menu/option-group/[optionGroupId]'),
);
const AddDishPage = lazy(() => import('./pages/menu/dishs/add'));
const InfoDishPage = lazy(() => import('./pages/menu/dishs/[dishId]'));
const MenuArrangementPage = lazy(() => import('./pages/menu/arrangement'));
const UpdateDishsStatusPage = lazy(
  () => import('./pages/menu/update-dishs-status'),
);
// const ChooseDishToMenuPage = lazy(() => import('./pages/menu/choose-dish'));
const SettingPage = lazy(() => import('./pages/settings'));
const OpenningHoursPage = lazy(() => import('./pages/settings/openning-hours'));
const InfoOpenningHoursPage = lazy(
  () => import('./pages/settings/openning-hours/[date]'),
);
const ScheduleSpecialDatesPage = lazy(
  () => import('./pages/settings/schedule-special-dates'),
);
const InfoSpecialDatePage = lazy(
  () => import('./pages/settings/schedule-special-dates/[date]'),
);
const SettingEmployeePage = lazy(() => import('./pages/settings/employee'));
const AddEmployeePage = lazy(() => import('./pages/settings/employee/add'));
const InfoEmployeePage = lazy(
  () => import('./pages/settings/employee/[employee]'),
);

const AddWorkTimeSpecialPage = lazy(
  () => import('./pages/settings/schedule-special-dates/add'),
);
const OrdersPage = lazy(() => import('./pages/oders-v2'));
const OrdersReportedPage = lazy(() => import('./pages/orders-reported'));
const OrdersHistoryPage = lazy(() => import('./pages/orders-history'));
const RatingsAndReviewsPage = lazy(
  () => import('./pages/statistics/ratings-reviews'),
);
const FinancePage = lazy(() => import('./pages/statistics/finance'));
const NotificationsPage = lazy(() => import('./pages/notifications'));
const NotificationContentPage = lazy(
  () => import('./pages/notifications/[notificationId]'),
);
const ProfilePage = lazy(() => import('./pages/profile'));
const RestaurantsPage = lazy(() => import('./pages/restaurants'));
const RestaurantInfoPage = lazy(() => import('./pages/settings/restaurant'));
const RestaurantRegisterPage = lazy(
  () => import('./pages/restaurant-register'),
);
const NoRestaurantYetPage = lazy(
  () => import('./pages/restaurant-register/components/NoRestaurantYetPage'),
);
const EditMainThumbnailRestaurantPage = lazy(
  () => import('./pages/settings/restaurant/edit-main-thumbnail'),
);
const EditAdressRestaurantPage = lazy(
  () => import('./pages/settings/restaurant/edit-address'),
);
const RegisterPage = lazy(() => import('./pages/login/register'));
const VerificationAccountPage = lazy(
  () => import('./pages/login/verification'),
);
const EditPersonalProfilePage = lazy(
  () => import('./pages/profile/edit-personal'),
);
const EditProfilePhonePage = lazy(() => import('./pages/profile/edit-phone'));
const EditProfileEmailPage = lazy(() => import('./pages/profile/edit-email'));
const EditProfilePasswordPage = lazy(
  () => import('./pages/profile/edit-password'),
);


const routes: RouterType[] = [
  {
    path: '/',
    name: 'Trang chủ',
    hideInMenu: true,
    component: <Navigate to="/menus" />,
  },
  {
    path: '*',
    name: '404',
    layout: false,
    component: <Page404 />,
  },
  {
    path: '/login',
    name: 'Đăng nhập',
    layout: false,
    component: <LoginPage />,
  },
  {
    path: '/forgot-password',
    name: 'Quên mật khẩu',
    layout: false,
    component: <ForgotPassPage />,
  },
  {
    path: '/change-default-password',
    name: 'Đổi mật khẩu',
    layout: false,
    component: <ChangeDefaultPasswordPage />,
  },
  {
    path: '/password',
    name: 'Mật khẩu',
    layout: false,
    routes: [
      {
        path: '/email-reset',
        name: 'Đặt lại mật khẩu',
        component: <ResetPasswordPage />,
      },
    ],
  },
  {
    path: '/logout',
    name: 'Đăng xuất',
    layout: false,
    component: <LogoutPage />,
  },
  {
    path: '/register',
    name: 'Đăng ký',
    layout: false,
    component: <RegisterPage />,
  },
  {
    path: '/verification',
    name: 'Kích hoạt Email',
    layout: false,
    component: <Navigate to="/login" />,
    routes: [
      {
        path: '/email',
        name: 'Kích hoạt Email',
        component: <VerificationAccountPage />,
      },
    ],
  },
  {
    path: '/restaurants',
    name: 'Danh sách nhà hàng',
    layout: false,
    component: <RestaurantsPage />,
  },
  {
    path: '/restaurant-register',
    name: 'Đăng ký nhà hàng mới',
    layout: false,
    component: <RestaurantRegisterPage />,
  },
  {
    path: '/no-restaurant-yet',
    name: 'Chưa có nhà hàng nào',
    layout: false,
    component: <NoRestaurantYetPage />,
  },
  {
    path: '/profile',
    name: 'Thông tin tài khoản',
    hideInMenu: true,
    component: <ProfilePage />,
    routes: [
      {
        path: '/edit-personal',
        name: 'Cá nhân',
        component: <EditPersonalProfilePage />,
      },
      {
        path: '/edit-phone-number',
        name: 'Số điện thoại',
        component: <EditProfilePhonePage />,
      },
      {
        path: '/edit-email',
        name: 'Email đăng nhập',
        component: <EditProfileEmailPage />,
      },
      {
        path: '/edit-password',
        name: 'Mật khẩu',
        component: <EditProfilePasswordPage />,
      },
    ],
  },
  {
    path: '/orders',
    name: 'Đơn hàng',
    icon: (
      <span className="anticon ant-menu-item-icon">
        <OrderIconOutlined />
      </span>
    ),
    component: <OrdersPage />,
    badgeName: KeyCountStateMenu.ORDERS
  },
  {
    path: '/menus',
    name: 'Thực đơn',
    icon: (
      <span className="anticon ant-menu-item-icon">
        <ForkKnifeOutlinedIcon />
      </span>
    ),
    hideChildrenInMenu: true,
    component: <MenuPage tab="dishs" />,
    routes: [
      {
        path: '/categories',
        name: 'Danh mục thực đơn',
        hideBreadcrumb: false,
        component: <MenuPage tab="categories" />,
        routes: [
          {
            path: '/add',
            name: 'Thêm danh mục mới',
            component: <AddCategoryPage />,
          },
          {
            path: '/:menuId',
            name: 'Thông tin danh mục',
            component: <InfoDishPage />,
          },
        ],
      },
      {
        path: '/dishs',
        name: 'Món ăn',
        component: <MenuPage tab="dishs" />,
        hideBreadcrumb: false,
        routes: [
          {
            path: '/add',
            name: 'Thêm món mới',
            component: <AddDishPage />,
          },
          {
            path: '/:dishId',
            name: 'Thông tin món',
            component: <InfoDishPage />,
          },
        ],
      },
      {
        path: '/arrangement',
        name: 'Sắp xếp thực đơn',
        component: <MenuArrangementPage />,
      },
      {
        path: '/option-groups',
        name: 'Nhóm tuỳ chọn',
        hideBreadcrumb: false,
        component: <MenuPage tab="option-groups" />,
        routes: [
          {
            path: '/add',
            name: 'Thêm nhóm tuỳ chọn mới',
            component: <OptionGroupInfoPage />,
          },
          {
            path: '/:optionGroupId',
            name: 'Thông tin Nhóm tuỳ chọn',
            component: <InfoOptionGroupPage />,
          },
        ],
      },
      // {
      //   path: '/add-item-to-category',
      //   name: 'Chọn món vào danh mục',
      //   component: <ChooseDishToMenuPage />,
      // },
      {
        path: '/update-dishs-status',
        name: 'Cập nhật trạng thái Món ăn',
        component: <UpdateDishsStatusPage />,
      },
      {
        path: '/selling-schedule',
        name: 'Lịch bán',
        component: <MenuPage tab="selling-schedule" />,
        routes: [
          {
            path: '/add',
            name: 'Thêm lịch bán',
            component: <AddSellingSchedulePage />,
          },
          {
            path: '/:scheduleId/edit',
            name: 'Chỉnh sửa lịch bán',
            component: <EditSellingSchedulePage />,
          }
        ],
      },
    ],
  },
  {
    path: '/notifications',
    name: 'Thông báo',
    icon: <BellOutlined />,
    component: <NotificationsPage />,
    hideChildrenInMenu: true,
    routes: [
      {
        path: '/:notificationId',
        name: 'Nội dung thông báo',
        component: <NotificationContentPage />,
      },
    ],
  },
  {
    path: '/orders-history',
    name: 'Lịch sử đơn hàng',
    icon: <HistoryOutlined />,
    component: <OrdersHistoryPage />,
  },
  {
    path: '/reported-orders',
    name: 'Đơn khiếu nại',
    icon: <AlertOutlined />,
    component: <OrdersReportedPage />,
  },
  {
    path: '/statistics',
    name: 'Thống kê',
    icon: <PieChartOutlined />,
    routes: [
      {
        path: '/ratings-and-reviews',
        name: 'Đánh giá',
        component: <RatingsAndReviewsPage />,
      },
      {
        path: '/finance',
        name: 'Tài chính',
        component: <FinancePage />,
      },
    ],
  },
  {
    path: '/promotions',
    name: 'Khuyến mãi',
    icon: <GiftOutlined />,
    component: <Navigate to="restaurant" />,
    routes: [
      {
        path: '/restaurant',
        name: 'Nhà hàng',
        component: <RestaurantPromotionsPage />,
      },
      {
        path: '/yougo',
        name: 'YouGo',
        component: <Navigate to="joined" />,
        routes: [
          {
            path: '/joined',
            name: 'Đã tham gia',
            component: <YougoPromotionsPage tab="joined" />,
          },
          {
            path: '/canjoin',
            name: 'Có thể tham gia',
            component: <YougoPromotionsPage tab="canjoin" />,
          },
        ],
      },
    ],
  },
  {
    path: '/settings',
    name: 'Cài đặt',
    icon: <SettingOutlined />,
    component: <SettingPage />,
    hideChildrenInMenu: true,
    routes: [
      {
        path: '/restaurant',
        name: 'Thông tin nhà hàng',
        component: <RestaurantInfoPage />,
        routes: [
          {
            path: '/edit-main-thumbnail',
            name: 'Ảnh bìa và Logo',
            component: <EditMainThumbnailRestaurantPage />,
          },
          {
            path: '/edit-address',
            name: 'Địa chỉ',
            component: <EditAdressRestaurantPage />,
          },
        ],
      },
      {
        path: '/opening-hours',
        name: 'Giờ mở cửa',
        component: <OpenningHoursPage />,
        routes: [
          {
            path: '/:date',
            name: 'Thông tin giờ mở cửa',
            component: <InfoOpenningHoursPage />,
          },
        ],
      },
      {
        path: '/schedule-special-dates',
        name: 'Giờ hoạt động đặc biệt',
        component: <ScheduleSpecialDatesPage />,
        routes: [
          {
            path: '/add',
            name: 'Thêm Giờ hoạt động đặc biệt',
            component: <AddWorkTimeSpecialPage />,
          },
          {
            path: '/:date',
            name: 'Thông tin Giờ hoạt động đặc biệt',
            component: <InfoSpecialDatePage />,
          },
        ],
      },
      {
        path: '/employees',
        name: 'Nhân viên',
        component: <SettingEmployeePage />,
        routes: [
          {
            path: '/add',
            name: 'Thêm Nhân viên',
            component: <AddEmployeePage />,
          },
          {
            path: '/:employee',
            name: 'Thông tin Nhân viên',
            component: <InfoEmployeePage />,
          },
        ],
      },
    ],
  },
];
const genListRoute = (route: RouterType, parentPath: string) => {
  const newPath = parentPath + route.path;

  const newRoute = {
    ...route,
    path: newPath,
  };
  const items = [newRoute];

  if (route.routes) {
    route.routes.forEach((x) => {
      const child = genListRoute(x, newPath);
      items.push(...child);
    });
  }
  return items;
};

function App() {
  const [loading, setLoading] = useState(true);
  const { currentUser } = useAppSelector((state) => state.user);
  const { restaurants, currentRestaurant } = useAppSelector(
    (state) => state.restaurant,
  );
  const countState = useAppSelector(
    (state) => state.countSlice,
  );

  const dispath = useAppDispatch();
  const location = useLocation();

  useEffect(() => {
    const initState = async () => {
      const value = localStorage.getItem('user');
      const userCached =
        typeof value === 'string' ? JSON.parse(value) : undefined;
      if (userCached) {
        await Promise.all([
          // await dispath(fetchCurrentUser()), // get latest info user
          await dispath(fetchRestaurants()),
        ]);

        setLoading(false);
      } else {
        setLoading(false);
      }
    };
    initState();
  }, [dispath]);

  useEffect(() => {
    if (currentRestaurant) {
      dispath(fetchOrders({
        restaurantId: currentRestaurant.id,
        orderTab: OrderTab.NEW
      }));
    }
  }, [dispath, currentRestaurant]);

  if (loading) return <PageLoading />;

  if (
    !currentUser &&
    location.pathname !== '/login' &&
    location.pathname !== '/register' &&
    location.pathname !== '/forgot-password' &&
    location.pathname !== '/password/email-reset' &&
    location.pathname !== '/verification/email' &&
    location.pathname !== '/change-default-password'
  )
    return <Navigate to="/login" />;

  if (
    !!currentUser &&
    restaurants?.length === 0 &&
    location.pathname !== '/no-restaurant-yet' &&
    location.pathname !== '/restaurant-register' &&
    location.pathname !== '/logout'
  ) {
    return <Navigate to="/no-restaurant-yet" />;
  }

  if (
    !!currentUser &&
    restaurants?.length > 0 &&
    location.pathname === '/no-restaurant-yet'
  ) {
    return <Navigate to="/" />;
  }

  return (
    <Layout
      currentUser={currentUser}
      routes={routes}
      rightHeader={
        <>
          <RestaurantStatuses />
          <RestaurantSelector />
          <UserInfo direction="rtl" />
        </>
      }
      customItemSidebar={<RestaurantSelectorMobile />}
      typeApp='merchant'
      countState={countState}
    >
      <Suspense fallback={<PageLoading />}>
        <Routes>
          {routes.map((route) => {
            const routeList = genListRoute(route, '');
            return (
              <Fragment key={route.path}>
                {routeList.map((x) => {
                  return (
                    <Route key={x.path} path={x.path} element={x.component} />
                  );
                })}
              </Fragment>
            );
          })}
        </Routes>
      </Suspense>
    </Layout>
  );
}

export default App;
